import { http } from "../../utils/config";

const menuAPI = {
    getActions: () => {
        return http.get(`/api/v1/security/menus`);
    },

    sortMenu: (menuData) => {
        return http.post('/api/v1/security/menus/sort', menuData);
    },

    // Delete
    deleteMenu: (id) => {
        return http.delete(`/api/v1/security/menus/${id}`);
    },

    // Update
    statusMenu: (id, menuData) => {
        return http.put(`/api/v1/security/menus/${id}/active`, menuData);
    },

    // Create new 
    createMenu: (menuData) => {
        return http.post('/api/v1/security/menus', menuData);
    },

    getById: (id) => {
        return http.get(`/api/v1/security/menus/${id}`);
    },

    // Update
    update: (id, data) => {
        return http.put(`/api/v1/security/menus/${id}`, data);
    },
};

// Helper functions for handling API responses
export const permissionHelpers = {
  
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response;
    } catch (error) {
      console.error('API Error:', error);
      
      // Handle different types of errors
      if (error.response) {
        // Server responded with error status
        const { status, data } = error.response;
        switch (status) {
          case 400:
            throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 401:
            throw new Error('Bạn cần đăng nhập để thực hiện thao tác này');
          case 403:
            throw new Error('Bạn không có quyền thực hiện thao tác này');
          case 404:
            throw new Error('Không tìm thấy khách hàng');
          case 422:
            throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 500:
            throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
          default:
            throw new Error(data.message || 'Đã có lỗi xảy ra');
        }
      } else if (error.request) {
        // Network error
        throw new Error('Không thể kết nối đến server');
      } else {
        // Other error
        throw new Error(error.message || 'Đã có lỗi xảy ra');
      }
    }
  };
};

// Wrapped API functions with error handling
export const menuAPIWithErrorHandling = {
  getActions: withErrorHandling(menuAPI.getActions),
  sortMenu: withErrorHandling(menuAPI.sortMenu),
  deleteMenu: withErrorHandling(menuAPI.deleteMenu),
  statusMenu: withErrorHandling(menuAPI.statusMenu),
  createMenu: withErrorHandling(menuAPI.createMenu),
  getById: withErrorHandling(menuAPI.getById),
  update: withErrorHandling(menuAPI.update),
};

export default menuAPI;